module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-700.woff2?334d1833a21eac00610249bcafff9c3b";